function formatMonthYYYY(dateStr) {
    if (/^\d{4}-\d{2}$/.test(dateStr)) {
        const [y, m] = dateStr.split('-').map(Number);
        const dt = new Date(y, m - 1, 1);
        return dt.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
    }
    const dt = new Date(dateStr);
    return dt.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
}

function parseAPIDate(dateStr) {
    if (/^\d{4}-\d{2}$/.test(dateStr)) {
        const [y, m] = dateStr.split('-').map(Number);
        return new Date(y, m - 1, 1);
    }
    return new Date(dateStr);
}

function toLocalISODateYYYYMMDD(d) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

const getPreviousSixMonths = () => {
    const months = [];
    const currentDate = new Date();
    
    // Generate current month + previous 5 months (total 6 months)
    for (let i = 0; i < 6; i++) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        const monthYear = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        
        months.unshift({ // unshift to maintain chronological order
            monthKey,
            monthYear
        });
    }
    
    return months;
};

export {
    formatMonthYYYY,
    parseAPIDate,
    toLocalISODateYYYYMMDD,
    getPreviousSixMonths,
}